import styled from 'styled-components';

export const Container = styled.div`
  height: 75vh;
  overflow-y: scroll;

  ol {
    padding-left: 25px;
  }
`;

// Título de seção no mesmo destaque do export (negrito, Times New Roman)
export const BlockTitle = styled.div`
  font-family: 'Times New Roman', times, serif;
  font-size: 19px;
  font-weight: 700;
  margin: 24px 0 8px;
`;
